import Vue from 'vue'
import Router from 'vue-router'
import Mapper from '@/components/data-mapper/mapper.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/mapper',
      name: 'data-mapper',
      component: Mapper
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js